import $ from 'jquery'

class Wearhouse {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		if (window.innerWidth > 765) {
			myObj.WearhouseFunction()
		} else {
			myObj.MobileAnimation()
		}
	}

	MobileAnimation() {
		let myTimeline = new TimelineLite()
		myTimeline
			.add('start', 0)
			.add('frameTwo', 2)
			.staggerFromTo(
				'.wOverlay',
				0.3,
				{
					clip: 'rect(0px,1920px,0px,0px)',

					opacity: 0.5,
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',

					opacity: 1,
				},
				0.2,
				'start'
			)
			.staggerFrom('.wModal', 0.5, { opacity: 0, delay: 0.2 }, 0.2, 'start')
			.staggerFromTo(
				'.wLine',
				0.5,
				{
					clip: 'rect(0px,0px,1090px,1920px)',
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',

					delay: 0.5,
				},
				0.2,
				'start'
			)
			.to('.wear-main-image', 1, { opacity: 0.2, delay: 0.2 }, 'start')
			.to('.wHide', 0.3, { opacity: 0 }, 'frameTwo')
			.from('.fade-in-left', 1, { opacity: 0, x: -300 }, 'frameTwo')

		// init controller
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#wearhouseMobile',
			// offset: window.innerHeight / 2,
			// duration: window.innerHeight * 3,
		})
			.setTween(myTimeline) // trigger a TweenMax.to tween
			// .addIndicators({ name: '1 (duration: 0)' })
			// .setPin('#wearhouse')
			.addTo(controller)
	}
	//? 3. methods (functions)
	WearhouseFunction() {
		let myTimeline = new TimelineLite()
		myTimeline
			.add('start', 0)
			.add('frameTwo', 2)
			.staggerFromTo(
				'.wOverlay',
				0.3,
				{
					clip: 'rect(0px,1920px,0px,0px)',

					opacity: 0.5,
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',

					opacity: 1,
				},
				0.2,
				'start'
			)
			.staggerFrom('.wModal', 0.5, { opacity: 0, delay: 0.2 }, 0.2, 'start')
			.staggerFromTo(
				'.wLine',
				0.5,
				{
					clip: 'rect(0px,0px,1090px,1920px)',
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',

					delay: 0.5,
				},
				0.2,
				'start'
			)
			.to('.wear-main-image', 1, { opacity: 0.08, delay: 0.2 }, 'start')
			.to('.wHide', 0.3, { opacity: 0 }, 'frameTwo')
			.from('.fade-in-left', 1, { opacity: 0, x: -300 }, 'frameTwo')
		// init controller
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#wearhouse',
			offset: window.innerHeight / 2,
			duration: window.innerHeight * 2.5,
		})
			.setTween(myTimeline) // trigger a TweenMax.to tween
			// .addIndicators({ name: '1 (duration: 0)' })
			.setPin('#wearhouse')
			.addTo(controller)
	}
}

export default Wearhouse
